import z from "zod"

import { DragDropBaseSchema } from "./DragDropBase"

export const DropTargetSchema = DragDropBaseSchema.extend({
  accept: z.array(z.string()).optional(),
  error: z.boolean().optional(),
  sameOrigin: z.boolean().optional()
})

interface DropTargetBase<Data> extends z.infer<typeof DropTargetSchema> {
  data: Data
}

export type DropTarget<Data = unknown, Meta = unknown> = unknown extends Meta
  ? DropTargetBase<Data> & { meta?: Meta }
  : DropTargetBase<Data> & { meta: Meta }

export function isDropTarget(value: unknown): value is DropTarget

export function isDropTarget<
  DataSchema extends z.ZodTypeAny | undefined = undefined,
  MetaSchema extends z.ZodTypeAny | undefined = undefined
>(
  value: unknown,
  options?: { dataSchema?: DataSchema; metaSchema?: MetaSchema }
): value is DropTarget<
  DataSchema extends z.ZodTypeAny ? z.infer<DataSchema> : undefined,
  MetaSchema extends z.ZodTypeAny ? z.infer<MetaSchema> : undefined
>

export function isDropTarget(
  value: unknown,
  options?: { dataSchema?: z.ZodType; metaSchema?: z.ZodType }
): value is DropTarget {
  const { dataSchema, metaSchema } = options || {}

  const schema = DropTargetSchema.extend({
    data: dataSchema || z.any(),
    meta: metaSchema || z.any()
  })

  return schema.safeParse(value).success
}
